export const WISHLIST_PENDING_STORAGE_KEY = 'wishlist/pending';
